<template>
    <v-container fluid class="pa-0 background-color-toolbar" v-resize="onResize">
        <v-overlay color="#106c68" :value="loadingState" z-index="12" style="left: -57px;">
            <span class="loader"></span>
        </v-overlay>
        <v-row no-gutters class="font-theme standard-row position-toolbar-setting">
            <v-toolbar color="#F0F0F0" class="standard-row toolbar-block d-flex justify-space-between">
                <div class="d-flex align-center">
                    <v-toolbar-title v-if="windowSize.x > 1295" @click="beforeRouteTo('/selected_business')" style="cursor: pointer;">
                        <img height="50px" src="../assets/logo-toolbar-pc-mc.png">
                    </v-toolbar-title>
                    <v-toolbar-title v-else>
                        <img height="77px" src="../assets/logo-toolbar-mobile-mc.png" @click="beforeRouteTo('/selected_business')" style="cursor: pointer; margin-right: 10px;">
                        <v-menu v-if="windowSize.x <= 924" offset-y attach transition="scroll-y-transition" :close-on-content-click="true" class="menu-toolbar-mobile" content-class="list-top-menu-toolbar">
                            <template v-slot:activator="{ on }">
                                <v-btn text v-on="on" class="px-0 mt-n16 ml-n2">
                                    <v-icon large>mdi-menu</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense nav class="list-item-menu-toolbar-mobile">
                                <v-list-item to="/selected_business" active-class="active-menu-toolbar-mobile" style="color: white;">
                                    <v-list-item-title class="header-menu-toolbar-mobile font-theme ml-6 mr-14">
                                        Business
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item to="/inbox" v-if="selectedBiz.tax_id != '0107544000094'" :event="''" active-class="active-menu-toolbar-mobile" style="color: white;" @click.native.prevent="beforeRouteTo('/inbox')">
                                    <v-list-item-title class="header-menu-toolbar-mobile font-theme ml-6 mr-14">
                                        Inbox
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-group no-action color="#868F95" @click.stop="" v-else> 
                                    <template v-slot:activator>
                                        <v-list-item-title active-class="active-menu-toolbar-mobile" style="color: white;" class="header-menu-toolbar-mobile font-theme white--text ml-6 mr-8 color-icon-budget-toolbar-mobile">
                                            Inbox
                                        </v-list-item-title>
                                    </template>
                                    <v-list style="background-color: #414040;" class="py-0">
                                        <v-list-item to="/inbox" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/inbox')" :active-class="$route.path === '/inbox'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Inbox Purchase Requisition
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-if="selectedBiz.tax_id ==='0107544000094'" to="/inbox_cs_po" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/inbox_cs_po')" :active-class="$route.path === '/inbox_cs_po'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Inbox CS to PO
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-if="selectedBiz.tax_id ==='0107544000094' || selectedBiz.tax_id ==='0105548134654'" to="/cut_petty_cash" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/cut_petty_cash')" :active-class="$route.path === '/cut_petty_cash'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Petty Cash
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item  v-if="setPermissionSummary === true" to="/summary_finance" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/summary_finance')" :active-class="$route.path === '/summary_finance'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Advance payment
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-list-group>
                                <v-list-group no-action color="#868F95" @click.stop="" v-if="selectedBiz.tax_id == '0107544000094'">
                                    <template v-slot:activator>
                                        <v-list-item-title active-class="active-menu-toolbar-mobile" style="color: white;" class="header-menu-toolbar-mobile font-theme white--text ml-6 mr-8 color-icon-budget-toolbar-mobile">
                                            สร้างเอกสาร
                                        </v-list-item-title>
                                    </template>
                                    <v-list style="background-color: #414040;" class="py-0">
                                        <v-list-item to="/create_purchase" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/create_purchase')" :active-class="$route.path === '/budget_inbox'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Purchase Requisition
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item  v-if="selectedBiz.tax_id ==='0107544000094'" to="/create_cs_po" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/create_cs_po')"  :active-class="$route.path === '/create_cs_po'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  CS to PO
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item  v-if="selectedBiz.tax_id ==='0107544000094'" to="/create_cspo_wait_qt" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/create_cspo_wait_qt')"  :active-class="$route.path === '/create_cspo_wait_qt'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  CS to PO Waiting QT
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-list-group>
                              
                                <v-list-item to="/create_purchase" v-else :event="''" active-class="active-menu-toolbar-mobile" style="color: white;" @click.native.prevent="beforeRouteTo('/create_purchase')">
                                    <v-list-item-title class="header-menu-toolbar-mobile font-theme ml-6 mr-14">
                                        สร้างเอกสาร
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item to="/add_vendor" :event="''" active-class="active-menu-toolbar-mobile" style="color: white;" @click.native.prevent="beforeRouteTo('/add_vendor')">
                                    <v-list-item-title class="header-menu-toolbar-mobile font-theme ml-6 mr-14">
                                        Vendors List
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item to="/add_item" :event="''" active-class="active-menu-toolbar-mobile" style="color: white;" @click.native.prevent="beforeRouteTo('/add_item')">
                                    <v-list-item-title class="header-menu-toolbar-mobile font-theme ml-6 mr-14">
                                        Item List
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="setPermissionGlAccount === true" to="/add_gl_account" :event="''" active-class="active-menu-toolbar-mobile" style="color: white;" @click.native.prevent="beforeRouteTo('/add_gl_account')">
                                    <v-list-item-title class="header-menu-toolbar-mobile font-theme ml-6 mr-14">
                                    GL Account List
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-group no-action color="#868F95" @click.stop="">
                                    <template v-slot:activator>
                                        <v-list-item-title active-class="active-menu-toolbar-mobile" style="color: white;" class="header-menu-toolbar-mobile font-theme white--text ml-6 mr-8 color-icon-budget-toolbar-mobile">
                                            บันทึกงบ
                                        </v-list-item-title>
                                    </template>
                                    <v-list style="background-color: #414040;" class="py-0">
                                        <v-list-item to="/budget_inbox" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/budget_inbox')" :active-class="$route.path === '/budget_inbox'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Report Budgeting
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item to="/dashboard_budget" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/dashboard_budget', 'Cost')" :active-class="$route.query.budget_type === 'Cost'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Budgeting COST
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-if="setGetBudgetType.some(e => e.type_name === 'ต้นทุนวิจัยและพัฒนา (R&D)')" to="/dashboard_budget" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/dashboard_budget', 'RD')" :active-class="$route.query.budget_type === 'RD'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Budgeting RD
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-if="setGetBudgetType.some(e => e.type_name === 'ค่าใช้จ่ายขายและบริการ (SG&A)')" to="/dashboard_budget" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/dashboard_budget', 'SGA')" :active-class="$route.query.budget_type === 'SGA'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Budgeting SGA
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item to="/db_estimate_cost" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/db_estimate_cost')" :active-class="$route.path === '/db_estimate_cost'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  DB Estimate Cost
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-list-group>
                                <v-list-group no-action color="#868F95" @click.stop="">
                                    <template v-slot:activator>
                                        <v-list-item-title active-class="active-menu-toolbar-mobile" style="color: white;" class="header-menu-toolbar-mobile font-theme white--text ml-6 mr-8 color-icon-budget-toolbar-mobile">
                                            Other
                                        </v-list-item-title>
                                    </template>
                                    <v-list style="background-color: #414040;" class="py-0">
                                        <v-list-item to="/dashboard_memo" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/dashboard_memo')" :active-class="$route.path === '/dashboard_memo'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Memo
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item to="/all_document_cs_po" v-if="selectedBiz.tax_id == '0107544000094'" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/all_document_cs_po','INET')" :active-class="$route.path === '/all_document_cs_po'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  รวมเอกสาร CS to PO
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-if="selectedBiz.tax_id === '0107544000094'" to="/eval_vendor" :event="''" style="color: white;" @click.native.prevent="beforeRouteTo('/eval_vendor')" :active-class="$route.path === '/eval_vendor'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                            <v-list-item-title class="font-theme ml-7 mr-5" style="font-size: 15px; font-weight: 700;">
                                                •  Supplier Evaluation
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-list-group>
                            </v-list>
                        </v-menu>
                    </v-toolbar-title>
                </div>
                <v-spacer></v-spacer>
                <v-toolbar-title class="font-theme" v-if="windowSize.x > 924">
                    <router-link to="/inbox" :event="''" v-if="selectedBiz.tax_id != '0107544000094'" class="router-link-class px-4" @click.native.prevent="beforeRouteTo('/inbox')">
                        <span class="black--text">Inbox</span>
                    </router-link>
                    <v-menu v-else offset-y attach transition="slide-x-transition" content-class="list-top-menu-toolbar">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text color="black" :ripple="false" dark v-bind="attrs" v-on="on" class="menu-dropdown-toolbar mt-n1 rounded-0">
                                Inbox
                            </v-btn>
                        </template>
                        <v-list class="top-list-menu-toolbar">
                            <v-list-item class="px-6 mx-2" to="/inbox" :event="''"  @click.native.prevent="beforeRouteTo('/inbox')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Inbox Purchase Requisition</v-list-item-title>
                            </v-list-item>
                            <v-list-item  v-if="selectedBiz.tax_id ==='0107544000094'" class="px-6 mx-2" to="/inbox_cs_po" :event="''"  @click.native.prevent="beforeRouteTo('/inbox_cs_po')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Inbox CS to PO</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="selectedBiz.tax_id ==='0107544000094' || selectedBiz.tax_id ==='0105548134654'" class="px-6 mx-2" to="/cut_petty_cash" :event="''"  @click.native.prevent="beforeRouteTo('/cut_petty_cash')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Petty Cash</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="setPermissionSummary === true" class="px-6 mx-2" to="/summary_finance" :event="''"  @click.native.prevent="beforeRouteTo('/summary_finance')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Advance payment</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-menu offset-y attach transition="slide-x-transition" content-class="list-top-menu-toolbar" v-if="selectedBiz.tax_id == '0107544000094'">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text color="black" :ripple="false" dark v-bind="attrs" v-on="on" class="menu-dropdown-toolbar mt-n1 rounded-0">
                                สร้างเอกสาร
                            </v-btn>
                        </template>
                        <v-list class="top-list-menu-toolbar">
                            <v-list-item class="px-6 mx-2" to="/create_purchase" :event="''"  @click.native.prevent="beforeRouteTo('/create_purchase')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Purchase Requisition</v-list-item-title>
                            </v-list-item>
                            <v-list-item  v-if="selectedBiz.tax_id ==='0107544000094'" class="px-6 mx-2" to="/create_cs_po" :event="''"  @click.native.prevent="beforeRouteTo('/create_cs_po')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">CS to PO</v-list-item-title>
                            </v-list-item>
                            <v-list-item  v-if="selectedBiz.tax_id ==='0107544000094'" class="px-6 mx-2" to="/create_cspo_wait_qt" :event="''"  @click.native.prevent="beforeRouteTo('/create_cspo_wait_qt')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">CS to PO Waiting QT</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <router-link v-else to="/create_purchase" :event="''" class="router-link-class px-4" @click.native.prevent="beforeRouteTo('/create_purchase')">
                        <span class="black--text">สร้างเอกสาร</span>
                    </router-link>
                    <router-link to="/add_vendor" :event="''" class="router-link-class px-4" @click.native.prevent="beforeRouteTo('/add_vendor')">
                        <span class="black--text">Vendors List</span>
                    </router-link>
                    <router-link to="/add_item" :event="''" class="router-link-class px-4" @click.native.prevent="beforeRouteTo('/add_item')">
                        <span class="black--text">Item List</span>
                    </router-link>
                    <router-link v-if="setPermissionGlAccount === true" to="/add_gl_account" :event="''" class="router-link-class px-4" @click.native.prevent="beforeRouteTo('/add_gl_account')">
                        <span class="black--text">GL Account List</span>
                    </router-link>
                    <v-menu offset-y attach transition="slide-x-transition" content-class="list-top-menu-toolbar">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text color="black" :ripple="false" dark v-bind="attrs" v-on="on" class="menu-dropdown-toolbar mt-n1 rounded-0">
                                บันทึกงบ
                            </v-btn>
                        </template>
                        <v-list class="top-list-menu-toolbar">
                            <v-list-item class="px-6 mx-2" to="/budget_inbox" :event="''"  @click.native.prevent="beforeRouteTo('/budget_inbox')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Report Budgeting</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-6 mx-2" to="/dashboard_budget" :event="''" @click.native.prevent="beforeRouteTo('/dashboard_budget', 'Cost')" :active-class="$route.query.budget_type === 'Cost'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Budgeting COST</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="setGetBudgetType.some(e => e.type_name === 'ต้นทุนวิจัยและพัฒนา (R&D)')" class="px-6 mx-2" to="/dashboard_budget" :event="''" @click.native.prevent="beforeRouteTo('/dashboard_budget', 'RD')" :active-class="$route.query.budget_type === 'RD'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Budgeting RD</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="setGetBudgetType.some(e => e.type_name === 'ค่าใช้จ่ายขายและบริการ (SG&A)')" class="px-6 mx-2" to="/dashboard_budget" :event="''" @click.native.prevent="beforeRouteTo('/dashboard_budget', 'SGA')" :active-class="$route.query.budget_type === 'SGA'? 'active-top-list-item-menu-toolbar': 'blur-top-list-item-menu-toolbar'">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Budgeting SGA</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="px-6 mx-2" to="/db_estimate_cost" :event="''" @click.native.prevent="beforeRouteTo('/db_estimate_cost')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">DB Estimate Cost</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-menu offset-y attach transition="slide-x-transition" content-class="list-top-menu-toolbar">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text color="black" :ripple="false" dark v-bind="attrs" v-on="on" class="menu-dropdown-toolbar mt-n1 rounded-0">
                                Other
                            </v-btn>
                        </template>
                        <v-list class="top-list-menu-toolbar">
                            <v-list-item class="pl-6 mx-2" to="/dashboard_memo" :event="''"  @click.native.prevent="beforeRouteTo('/dashboard_memo')" active-class="active-top-list-item-menu-toolbar"  style="padding-right: 94px;">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Memo</v-list-item-title>
                            </v-list-item>
                            <v-list-item class="pl-6 mx-2" to="/all_document_cs_po" v-if="selectedBiz.tax_id == '0107544000094'" :event="''"  @click.native.prevent="beforeRouteTo('/all_document_cs_po','INET')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">รวมเอกสาร CS to PO</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="selectedBiz.tax_id ==='0107544000094'" class="pl-6 mx-2" to="/eval_vendor" :event="''"  @click.native.prevent="beforeRouteTo('/eval_vendor')" active-class="active-top-list-item-menu-toolbar">
                                <v-list-item-title class="top-list-item-menu-toolbar font-theme">Supplier Evaluation</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu attach :nudge-left="windowSize.x <= 1087 ? '52': ''" offset-y transition="scroll-y-transition" content-class="list-user-menu-toolbar">
                    <template v-slot:activator="{ on }">
                        <v-btn slot="activator" color="white" height="69" v-on="on" class="pl-2 pr-0" v-if="windowSize.x > 1160" style="border-radius: 3px; box-shadow: none;">
                            <v-img :src="aboutUser.imageProfile" width="49" height="53" style="border-radius: 7px;"></v-img>
                            <div no-gutters class="standard-row ml-2">
                                <v-row no-gutters class="standard-row d-flex justify-center" style="font-size: 12px; font-weight: 400;">
                                    {{ aboutUser.name }}
                                </v-row>
                                <v-row no-gutters class="standard-row d-flex justify-center" style="font-size: 12px; font-weight: 400;">
                                    {{ aboutUser.position }}
                                </v-row>
                            </div>
                            <v-icon color="#575757" class="pl-3">mdi-dots-vertical</v-icon>
                        </v-btn>
                        <v-btn color="white" height="69" v-on="on" class="pl-2 pr-0" v-else style="border-radius: 3px; box-shadow: none;">
                            <v-img :src="aboutUser.imageProfile" width="49" height="53" style="border-radius: 7px;"></v-img>
                            <v-icon color="#575757" class="pl-3">mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense class="font-theme py-2 list-item-user-toolbar">
                        <v-list-item v-if="OdPriority" to="/setting" color="#868F95" class="px-2 mx-2" active-class="active-menu-toolbar">
                            <v-list-item-icon class="ml-0 mr-5 my-3">
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.22407 2.71484H3.53048C2.13294 2.71484 1 3.90315 1 5.369V17.3132C1 18.779 2.13294 19.9673 3.53048 19.9673H16.1829C17.5804 19.9673 18.7134 18.779 18.7134 17.3132V11.3408" stroke="#2A2E3B" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7134 1.34378C19.4155 2.10473 19.4061 3.31566 18.6922 4.06444L9.85676 13.3317L6.06103 14.6588L7.32628 10.6775L16.1671 1.32744C16.8602 0.594326 17.9888 0.589416 18.6877 1.31647C18.6964 1.32548 18.705 1.33458 18.7134 1.34378Z" stroke="#2A2E3B" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M16.1829 4.04199L17.3886 5.36907" stroke="#2A2E3B" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="dropdown-user-toolbar pr-4">Setting</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="logOut()" color="#868F95" class="px-2 mx-2" active-class="active-menu-toolbar">
                            <v-list-item-icon class="ml-0 mr-5 my-3">
                                <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.16667 1C11.0997 1 12.6667 2.60498 12.6667 4.58481V5.77975C12.6667 7.75959 11.0997 9.36457 9.16667 9.36457C7.23367 9.36457 5.66667 7.75959 5.66667 5.77975V4.58481C5.66667 2.60498 7.23367 1 9.16667 1ZM17.3333 17.7291C17.3333 17.4391 17.3333 17.1491 17.3333 16.859C17.3333 13.0514 13.0327 10.5595 9.16667 10.5595C5.30067 10.5595 1 13.0514 1 16.859V17.7291C1 18.3891 1.52233 18.9241 2.16667 18.9241H16.1667C16.811 18.9241 17.3333 18.3891 17.3333 17.7291Z" stroke="#2A2E3B" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8567 1.21191C15.2039 1.71069 16.1668 3.0323 16.1668 4.58423V5.77917C16.1668 7.3291 15.2064 8.64929 13.8619 9.14955C14.6296 8.19463 15.0128 6.87169 15.0117 5.18073C15.0106 3.48977 14.6256 2.16683 13.8567 1.21191ZM19.6668 18.9235H20.8334C21.4778 18.9235 22.0001 18.3885 22.0001 17.7285C22.0001 17.4385 22.0001 17.1485 22.0001 16.8584C22.0001 14.2656 20.0058 12.2828 17.5124 11.2816C17.5124 11.2816 20.8334 14.1437 19.6668 18.9235Z" fill="#2A2E3B" stroke="#2A2E3B" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title class="dropdown-user-toolbar pr-4">Logout</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>
        </v-row>
        <v-container fluid class="pa-0">
            <router-view/>
        </v-container>
    </v-container>
</template>
  
<script>
import { EventBus } from '../EventBus'
import { mapActions } from 'vuex'
export default {
    data: () => ({
        isDev: false,
        raDetail: {},
        aboutUser: {},
        OdPriority: false,
        loadingState: false,
        windowSize: { x: 0 },
    }),
    mounted () {
        this.onResize()
        EventBus.$on('loadingState', this.changeStateLoader)
        this.raDetail = this.$store.getters.raDetail
        const devForTestFromEmployeeId = [
            'VGR2560304', //-----พลอย
            '64211', //-----น้องแมน
            '64195', //-----น้องลิ้ง
            '65279', //-----น้องราล์ฟ
            '66233', //-----น้องเพียว
            '63008', //-----พี่เน็ต
            '62575', //-----พี่บอส
            '62574', //-----พี่ณะ
            '67480', //-----น้องปลั๊ก
        ]
        this.isDev = devForTestFromEmployeeId.includes(this.raDetail.employee_id)
        this.aboutUser = {
            name         : `${this.raDetail?.first_name_en?.toUpperCase() || ''} ${this.raDetail?.last_name_en?.toUpperCase() || ''}`,
            position     : this.raDetail?.position?.position_name?.toUpperCase(),
            imageProfile : `https://inet-hr.inet.co.th/api/login/getProfilePicture/${this.raDetail.employee_id || 'none'}`
        }

        this.OdPriority = this.raDetail.orgchart?.department?.some(e => e.orgchartId?.replace(/ /g, "") === '60cadb53ecf68232741b7af2') || false //----- OD department only
        if (!this.OdPriority) {
            this.OdPriority = this.isDev
        }
    },
    beforeDestroy() {
        EventBus.$off('loadingState')
    },
    computed: {
        selectedBiz () {
            return this.$store.state.confirmSelectedBiz
        },
        permissionInbox() {
            return this.$store.state.permissionInbox
        },
        setGetBudgetType () {
                return this.$store.state.budgetType
        },
        pettyCashPermission() {
            return this.$store.getters.pettyCashPermission
        },
        setPermissionSummary() {
            return this.$store.getters.PermissionSummary
        },
        setPermissionGlAccount() {
            return this.$store.getters.permissionGlAccount
        }
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        changeStateLoader(state = false) {
            this.loadingState = state
        },
        logOut() {
            this.clearAllData()
            sessionStorage.clear();
            this.$router.push("/login");
        },
        ...mapActions({
            clearAllData: 'clearAll'
        }),
        async beforeRouteTo(path, queryTypeValue) {
            if (path === '/cut_petty_cash') {
                const hasPermission = await this.$store.state.pettyCashPermission
                if (hasPermission === true) {
                    this.$router.push(path)
                } else {
                    return this.alert('ไม่มีสิทธิ์การเข้า', 'Warning', 'warning')
                }
            } else {
                this.$router.push(path)
            }
            if (this.$route.path === path && !queryTypeValue) {
                return
            } else if (this.$route.path === path && queryTypeValue && queryTypeValue === this.$route.query.budget_type) {
                return
            }
            if (path === '/selected_business') {
                return this.$router.push(path)
            }
            if (Object.keys(this.selectedBiz).length && path) {
                if (path.startsWith('/dashboard_budget') && queryTypeValue) {
                    if (this.permissionInbox.length) {
                        for (let i = 0; i < this.permissionInbox.length; i++) {
                            if (this.selectedBiz.tax_id ==="0107544000094" && (queryTypeValue.toLowerCase() === this.permissionInbox[i].inbox?.toLowerCase())) {
                                this.$router.push({ path, query: { budget_type: queryTypeValue } })
                                break
                            //mandala save budget
                            } else if (this.$group_biz_tax_id_dashboard_budget.includes(this.selectedBiz.tax_id) && this.setGetBudgetType.some(e => e.type === queryTypeValue.toLowerCase()) && (this.permissionInbox[i].inbox?.toLowerCase() === 'บัญชี' || this.permissionInbox[i].inbox?.toLowerCase() === 'report')) {
                                this.$router.push({ path, query: { budget_type: queryTypeValue } })
                                break
                            }
                            if (i === this.permissionInbox.length - 1) {
                                return this.alert('ไม่มีสิทธิ์การเข้า', 'Warning', 'warning')
                            }
                        }
                    }
                } else if(path.startsWith('/budget_inbox')) {
                    if (this.permissionInbox.length) {
                        for (let i = 0; i < this.permissionInbox.length; i++) {
                            if (['cost', 'rd', 'sga', 'report'].includes(this.permissionInbox[i].inbox?.toLowerCase())) {
                                this.$router.push(path)
                                break
                            //mandala save budget 
                            } else if (this.$group_biz_tax_id.includes(this.selectedBiz.tax_id) && this.permissionInbox[i].inbox?.toLowerCase() === 'บัญชี' ) {
                                this.$router.push(path)
                                break
                            }
                            if (i === this.permissionInbox.length - 1) {
                                return this.alert('ไม่มีสิทธิ์การเข้า', 'Warning', 'warning')
                            }
                        }
                    }
                } else if(queryTypeValue == 'INET'){
                    if(this.selectedBiz.tax_id == '0107544000094'){
                        this.$router.push(path)
                    }else{
                        return this.alert('ไม่มีสิทธิ์การเข้า', 'Warning', 'warning')
                    }
                } else {
                    this.$router.push(path)
                }
            } else {
                this.alert('โปรดเลือกประเภทธุรกิจ', 'Warning', 'warning')
            }
        },
        alert(title = '', text = 'Warning', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text:  text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        }
    }
}
</script>
  
<style>
    .toolbar-block {
        height: 108px !important;
        box-shadow: none !important;
        background-image: radial-gradient(circle 340px at 10% 154%, rgba(59, 115, 201, 0.136) 55%, transparent 100%),
            radial-gradient(circle 225px at 40% 155%, rgba(59, 201, 133, 0.136) 55%, transparent 100%);
        background-size: 100% 100%, 100% 100%;
        background-repeat: no-repeat;
    }

    .toolbar-block .v-toolbar__content {
        height: 100% !important;
    }

    .dropdown-user-toolbar {
        font-size: 16px !important;
        font-weight: 400;
        line-height: 25px !important;
    }

    .list-item-user-toolbar {
        border-radius: 5px;
    }

    .list-item-menu-toolbar-mobile {
        border-radius: 0px !important;
        background: #414040 !important;
    }

    .list-item-user-toolbar .v-list-item:not(:last-child):not(:only-child) {
        border-radius: 0px;
        border-bottom: 1px solid #000000;
    }

    .list-item-menu-toolbar-mobile .v-list-item:not(:last-child):not(:only-child) {
        border-radius: 0px;
    }

    .router-link-class {
        text-decoration: none;
        font-size: 20px;
        font-weight: 700;
    }

    .menu-toolbar-mobile .v-menu__content {
        border-radius: 0px;
    }

    .menu-dropdown-toolbar {
        font-size: 20px !important;
        font-weight: 700;
        letter-spacing: 0px;
    }

    .color-icon-budget-toolbar-mobile > .v-list-item__icon  > .v-icon.v-icon {
        color: white !important;
    }

    .menu-dropdown-toolbar::before {
        background-color: transparent !important;
    }

    .position-toolbar-setting {
        position: sticky;
        top: 0px;
        z-index: 10;
        width: -webkit-fill-available;
        margin: 0%;
    }

    .toolbar-block .v-toolbar__content {
        padding: 0px 16px 0px 0px;
        width: 100vw;
        margin-left: 16px;
    }

    .active-menu-toolbar {
        color: black !important;
    }

    .active-menu-toolbar-mobile {
        background-color: #F1F1F1;
        color: black !important;
    }

    .top-list-menu-toolbar {
        background-color: #414040 !important;
    }

    .top-list-item-menu-toolbar {
        font-size: 15px;
    }

    .active-top-list-item-menu-toolbar {
        background-color: #F1F1F1;
        color: black !important;
        font-weight: 500;
    }

    .theme--light .top-list-menu-toolbar .v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: white !important;
    }

    .list-top-menu-toolbar {
        margin-top: 20px;
        contain: initial;
        overflow: visible;
    }

    .list-top-menu-toolbar::before {
        position: absolute;
        content: "";
        top: 2px;
        left: 25px;
        transform: translateY(-100%);
        width: 10px; 
        height: 13px; 
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 13px solid #414040;
    }

    .list-user-menu-toolbar {
        margin-top: 8px;
    }

    .v-menu__content {
        z-index: 10;
    }

    .header-menu-toolbar-mobile {
        font-size: 16px !important;
        font-weight: 700 !important;
        line-height: 22px !important;
    }

    .loader {
        width: 16px;
        height: 16px;
        box-shadow: 0 30px, 0 -30px;
        border-radius: 4px;
        background: currentColor;
        display: block;
        margin: -50px auto 0;
        position: relative;
        color: #FFF;
        transform: translateY(30px);
        box-sizing: border-box;
        animation: animationLoader 2s ease infinite;
    }

    .loader::after, .loader::before {
        content: '';  
        box-sizing: border-box;
        width: 16px;
        height: 16px;
        box-shadow: 0 30px, 0 -30px;
        border-radius: 4px;
        background: currentColor;
        color: #FFF;
        position: absolute;
        left: 30px;
        top: 0;
        animation: animationLoader 2s 0.2s ease infinite;
    }

    .loader::before {
        animation-delay: 0.4s;
        left: 10px;
    }
    
    @keyframes animationLoader {
        0% {
            top: 0;
            color: white;
        }
        50% {
            top: 30px;
            color: rgba(255, 255, 255, 0.2);
        }
        100% {
            top: 0;
            color: white;
        }
    }
    
    .blur-top-list-item-menu-toolbar {
        color: white !important;
        background: #414040 !important;
    }

    .blur-top-list-item-menu-toolbar::before {
        opacity: 0 !important;
    }

</style>